// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___2Xz1O","open":"open___2d2XG","truncateWithCount":"truncateWithCount___1Da1n"};